import { ProductTypes } from 'modules/products'
import {
  apiService,
  createRequestHeadersConfig,
  NestedApiResponse
} from 'shared/api'

import { CartResponseTypes, PackingOption } from './types'

const api = apiService()

type GetRecommendedProductsByCartPayload = {
  token?: string
  cartId: string
}

type GetRecommendedProductsByCartResponse = {
  data: {
    data: ProductTypes[]
  }
}

export const getRecommendedProductsByCart = (
  payload: GetRecommendedProductsByCartPayload
): Promise<GetRecommendedProductsByCartResponse> => {
  const { cartId, token } = payload

  return api.get(
    `/cart/${cartId}/recommended-products`,
    createRequestHeadersConfig(token)
  )
}

export const getPackingOptions = async (
  token: string | undefined
): Promise<PackingOption[]> => {
  const result: NestedApiResponse<{ data: PackingOption[] }> = await api.get(
    `/packages`,
    createRequestHeadersConfig(token)
  )

  return result.data.data || []
}

export const setPackingOption = async ({
  token,
  cartId,
  packingOptionId
}: {
  token: string | undefined
  cartId: string
  packingOptionId: string
}) => {
  const result: CartResponseTypes = await api.patch(
    `/cart/${cartId}/package/${packingOptionId}`,
    {},
    createRequestHeadersConfig(token)
  )

  return result?.data?.data || []
}
